
import BaseModel from './BaseModel';
export default class HomestayRates extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data);
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.homestayId = data.homestayId || undefined;
        this.mappingId = `${data.homestayId || ''}:${data.code || ''}` || undefined;
        this.name = this.translate.name || undefined;
        this.description = this.translate.description || undefined;
        this.shortDescription = this.translate.shortDescription || undefined;
        this.promotions = data.promotions || [];
        this.cancelPolicy = this.translate.cancelPolicy || undefined;
        this.code = data.code || undefined;
        this.refId = data.refId || undefined;
        this.order = this.order || 0;
        this.isDefault = data.isDefault || false;
        this.isActive = data.isActive || false;
        this.dc = data.dc || [];
        this.refStatus = data.status || false;
        this.usageStatus = data.status || false;
        this.isExtend = data.isExtend || false;
        this.isIndependent = this.translate.isIndependent || false;
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            homestayId : this.homestayId,
            name: this.name,
            description: this.description,
            shortDescription: this.shortDescription,
            promotions: this.promotions,
            cancelPolicy: this.cancelPolicy,
            code: this.code,
            refId: this.refId,
            order: this.order,
            isActive: this.isActive,
            isDefault: this.isDefault,
            usageStatus: this.usageStatus,
            isExtend: this.isExtend,
            isIndependent: this.isIndependent
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                homestayRatePlanId: this.translate.homestayRatePlanId || this.id,
                name: this.name,
                description: this.description,
                order: this.order,
                shortDescription: this.shortDescription,
                cancelPolicy: this.cancelPolicy,
                isActive: this.isActive,
                languageCode: this.languageCode,
                usageStatus: this.usageStatus,
                isExtend: this.isExtend,
                isIndependent: this.isIndependent
            }
        }
        return result;
    }
}

export class HomestayRateSync extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data);
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.code = data.code || undefined;
        this.name = data.name || undefined;
        this.description = data.description || undefined;
        this.dc = data.dc || [];
    }
}
